import { useEffect, useRef, useState } from 'react';
import FJConfig from '@src/config/FJConfig';
import styles from './FJSubtitleItem.module.less';
import FJHoverBoardGradation from '@src/common/components/FJHoverBoard/FJHoverBoardGradation';
import FJImage from '@src/common/components/FJImage/FJImage';

interface FJSubtitleStyleTile {
    id: string;
    text: string;
    imgUrl: string;
    /** 有值时 hover 自动播放预览（如 `.webm`） */
    videoUrl?: string;
}

interface FJSubtitleItemProps {
    styleItem: FJSubtitleStyleTile;
    selected: boolean;
    onSelect: (id: string) => void;
}

export default function FJSubtitleItem({ styleItem, selected, onSelect }: FJSubtitleItemProps) {
    const { id, text, imgUrl, videoUrl } = styleItem;
    const imgSrc = FJConfig.RESOURCE_SERVER + imgUrl;
    const resolvedVideoUrl = videoUrl != null && videoUrl.trim() !== '' ? FJConfig.RESOURCE_SERVER + videoUrl : null;

    const [hovered, setHovered] = useState(true);
    const videoRef = useRef<HTMLVideoElement>(null);

    useEffect(() => {
        const v = videoRef.current;
        if (!v || !hovered || !resolvedVideoUrl) {
            return;
        }
        v.play().catch(() => {});
        return () => {
            v.pause();
            v.currentTime = 0;
        };
    }, [hovered, resolvedVideoUrl, id]);

    const handleMouseLeave = () => {
        // videoRef.current?.pause();
        // setHovered(false);
    };

    return (
        <FJHoverBoardGradation
            onClick={() => onSelect(id)}
            active={selected}
            isShowInBorder={true}
            aria-label={text}
            aria-pressed={selected}
        >
            <button
                type='button'
                className={styles.root}
                onMouseEnter={() => resolvedVideoUrl && setHovered(true)}
                onMouseLeave={handleMouseLeave}
                onBlur={handleMouseLeave}
            >
                <span className={styles.media}>
                    <FJImage
                        imgSrc={imgSrc}
                        boxClassName={styles.media_image}
                        imgClassName={styles.thumb}
                        disableDefaultImgClass
                        alt=''
                    />
                    {resolvedVideoUrl && hovered ? (
                        <video
                            ref={videoRef}
                            className={styles.video}
                            src={resolvedVideoUrl}
                            muted
                            playsInline
                            loop
                            preload='none'
                            aria-hidden
                        />
                    ) : null}
                </span>
            </button>
        </FJHoverBoardGradation>
    );
}
